<div class="d-flex flex-column justify-content-center align-content-center">
  <div class="avatar ms-5 size-xl mb-3">
    <app-svg-icon
      [path]="'assets/icons/stats-item-icons/' + iconName + '.svg'"
    ></app-svg-icon>
  </div>
  <div class="text-center">
    <h4>{{ value }}</h4>
    <h6 class="h6-custom">{{ title }}</h6>
    <div *ngIf="!onTheMarketValue && link">
      <p>
        <a href="#/{{ link }}" class="text-decoration-none fw-bold text-white"
        i18n="Link statistiche | Pagina ricerca, form @@search-page.stats-item.link-list"
          >Vedi elenco <span class="sr-only">{{title}}</span> → </a
        >
      </p>
    </div>
    <p i18n="Testo statistiche | Pagina ricerca, form @@search-page.stats-item.text-trade"
    class="p-custom" *ngIf="onTheMarketValue">di cui {{onTheMarketValue}} in commercio</p>
  </div>
</div>
